export class MailStatusTransitionInput {
  public globalStatusId: number | string;
  public specificStatusId?: number | string;
  public comment?: string; // maxLength: 400
}
